import React, {useRef} from "react";
import css from './RequestHelpForm.css';
import {TextArea} from "semantic-ui-react";
import PropTypes from "prop-types";

const RequestHelpDetailsTextArea = ({
  details,
  isDetailsRequired,
  setDetails
}) => {
  const textAreaRef = useRef(null)

  return (
      <div className={css['input']}>
        <label ref={textAreaRef}
               htmlFor="details">
          {isDetailsRequired && <span>*</span>} Details</label>
        <TextArea
            id="details"
            value={details}
            onChange={e => setDetails(e.target.value)}
            aria-label="Details"
            onFocus={() => {
              setTimeout(() => textAreaRef.current.scrollIntoView(), 400);
            }}
        />
      </div>
  );

};

RequestHelpDetailsTextArea.propTypes = {
  details: PropTypes.string,
  isDetailsRequired: PropTypes.bool.isRequired,
  setDetails: PropTypes.func.isRequired
};

export default RequestHelpDetailsTextArea;
